import {
    AddCircleOutlineSharp,
    UpdateSharp,
    EmailSharp,
    ArchiveSharp,
    NoteAddSharp,
    LockSharp,
    LockOpenSharp,
    AttachmentSharp,
    DescriptionSharp,
    CalendarMonthSharp,
    EditNoteSharp,
    HelpOutlineSharp,
    CancelSharp,
    PeopleAltSharp,
    ViewInArSharp,
    PersonAddSharp
} from "@mui/icons-material";


import { blue, green, grey, orange, red } from "@mui/material/colors";

const getIconForLog = (message = "") => {
    const lower = message.toLowerCase();


    if (lower.startsWith("added")) return { icon: ViewInArSharp, color: green[500] };
    if (lower.startsWith("updated notes")) return { icon: EditNoteSharp, color: orange[500] };
    if (lower.startsWith("updated sales")) return { icon: PeopleAltSharp, color: orange[500] };
    if (lower.startsWith("updated")) return { icon: UpdateSharp, color: orange[500] };
    if (lower.startsWith("email") || lower.startsWith("emailed")) return { icon: EmailSharp, color: orange[500] };
    if (lower.startsWith("archived")) return { icon: ArchiveSharp, color: grey[500] };
    if (lower.startsWith("created quote")) return { icon: PersonAddSharp, color: green[500] };
    if (lower.startsWith("created")) return { icon: NoteAddSharp, color: green[700] };
    if (lower.startsWith("locked")) return { icon: LockSharp, color: red[500] };
    if (lower.startsWith("unlocked") || lower.startsWith("re-opened")) return { icon: LockOpenSharp, color: green[300] };
    if (lower.startsWith("removed")) return { icon: CancelSharp, color: red[500] };
    if (lower.startsWith("quote accepted")) return { icon: DescriptionSharp, color: green[500] };
    if (lower.startsWith("updated schedule") || lower.startsWith("added schedule")) return { icon: CalendarMonthSharp, color: blue[300] };

    return { icon: HelpOutlineSharp, color: grey[400] }; // Default if no match
};

export default getIconForLog;
